module.exports = __webpack_public_path__ + "static/media/wallsofarithtext.8a4955d3.jpg";